import { Spinner } from "react-bootstrap";
import integrationUtils from "../../../../Utils/integration.utils";
import { HGHighlightText } from "../../../App/App";
import ImageLoader from "../../../Common/ImageLoader";
import CrossIcon from "../../../icons/cross.icon";


const ConnectedToolItem = ({ tool, searchValue = "", passedStyle, passedIdKey, showCross = false, onCrossClick = () => {}, isLoading = false, showManagedBySOCIcon = false }) => {
  const image = integrationUtils.getImagePath(passedIdKey ? tool?.[passedIdKey] : tool?.obj_IntegrationId, tool?.ToolIcon);

  const handleCrossClick = (e) => {
    onCrossClick(e, tool?.obj_IntegrationId);
  }

  return (
    <div className={`d-flex ${passedStyle && passedStyle}`}>
      <div
        className="d-flex align-items-center connected-tool w-fit-content"
      >
        <ImageLoader
          alt=""
          width={16}
          height={16}
          className="rounded-full"
          style={{ marginLeft: '3px' }}
          src={image}
          noImageComponent={(
            <img
              alt=""
              width={16}
              height={16}
              className="rounded-full"
              style={{ marginLeft: '3px' }}
              src={"/images/attack-surface/generic2-dark.svg"}
            />
          )}
        />
        <div className="connected-tool-text align-items-center">
          <span
            dangerouslySetInnerHTML={{
              __html: HGHighlightText(
                tool?.ToolName,
                searchValue
              ),
            }}
          />
        </div>
        {showManagedBySOCIcon && (
          <img
           width={14}
           alt=""
           className="mx-1"
           src="/images/icons/monitor-icon.svg"
         />
        )}
        {showCross && (
          <button className="cross-button my-button mr-2 d-flex align-items-center justify-content-center" onClick={handleCrossClick}>
            {isLoading ? (
              <Spinner
                animation="border"
                variant="secondary"
                size="sm"
                style={{ width: "12px", height: "12px", marginBottom: '2px' }}
              />
            ) : <CrossIcon className="f-darkgrey" />}
          </button>
        )}
      </div>
    </div>
  );
}

export default ConnectedToolItem;
